<template>
  <div class="low-layout">
    <slot></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
</style>